// FaqSection.jsx
import React from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FaqSection = ({ faqsSection }) => {
  const theme = useTheme();

  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  if (!faqsSection?.services?.length) return null;

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        py: { md: 12, xs: 8 },
        px: { md: 14, xs: 3 },
        backgroundColor: "#fff",
      }}
    >
      {/* Title */}
      <Box sx={{ textAlign: "center", mb: { md: 5, xs: 4 } }}>
        <Typography
          sx={{ fontSize: { md: "32px", xs: "22px" }, fontWeight: 800 }}
        >
          {faqsSection?.heading || "Frequently Asked Questions"}
        </Typography>

        <Box
          sx={{
            height: 3,
            width: 84,
            backgroundColor: "#2EAD9F",
            borderRadius: 2,
            margin: "10px auto 0",
          }}
        />

        <Typography sx={{ fontSize: 13, mt: 1, color: "#666" }}>
          Got questions? We’ve got answers.
        </Typography>
      </Box>

      {/* Accordions */}
      <Box sx={{ maxWidth: 1100, mx: "auto" }}>
        {faqsSection.services.map((faq, idx) => {
          const panelId = `panel${idx + 1}`;
          const isExpanded = expanded === panelId;

          return (
            <Accordion
              key={panelId}
              expanded={isExpanded}
              onChange={handleChange(panelId)}
              elevation={0}
              sx={{
                boxShadow: "0 6px 18px rgba(19,22,24,0.04)",
                borderRadius: "10px",
                mb: 2.5,
                "&:before": {
                  display: "none",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#2EAD9F" }} />}
                aria-controls={`${panelId}-content`}
                id={`${panelId}-header`}
                sx={{
                  minHeight: 64,
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                    alignItems: "center",
                  },
                  px: { md: 4, xs: 3 },
                  py: { md: 1.5, xs: 1 },

                  ...(isExpanded && {
                    backgroundColor: "#BEEDE6",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                  }),
                }}
              >
                <Typography sx={{ fontWeight: 700 }}>
                  {faq.label}
                </Typography>
              </AccordionSummary>

              <AccordionDetails
                sx={{
                  px: { md: 4, xs: 3 },
                  pt: 2.5,
                  pb: 3,
                  borderBottomLeftRadius: "10px",
                  borderBottomRightRadius: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "#5f6468",
                    lineHeight: 1.8,
                  }}
                >
                  {faq.content}
                </Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </Box>
  );
};

export default FaqSection;